<div class="wrapper-billing">
    <div class="section-text row">
        <div class="section-btn">
            <button class="btn btn-back rounded-circle mt-2">
              <i class="fi-rr-arrow-alt-left"></i>
            </button>
        </div>
        <div>
            <h1 class="title">Billing History</h1>
        </div>
    </div>

    <div class="section-action">
        <div>
            <img class="all-icon" src="../../../assets/icon/all.svg" alt="icon">
            <div ngbDropdown class="d-inline-block w-100">
                <button class="btn btn-outline-primary text-indent-40" id="dropdownBasic1" ngbDropdownToggle>All</button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="custom-dropdown">
                    <button ngbDropdownItem>Dropdown 1</button>
                    <button ngbDropdownItem>Dropdown Active</button>
                    <button ngbDropdownItem>Dropdown 2</button>
                    <button ngbDropdownItem>Dropdown 2</button>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div ngbDropdown class="d-inline-block w-100">
                <button class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>Product/Transaction/ID</button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="custom-dropdown">
                    <button ngbDropdownItem>Dropdown 1</button>
                    <button ngbDropdownItem>Dropdown Active</button>
                    <button ngbDropdownItem>Dropdown 2</button>
                    <button ngbDropdownItem>Dropdown 2</button>
                </div>
            </div>
        </div>
    </div>

    <div class="section-main">
        <div class="table-history table-responsive mx-auto">
            <table class="table">
                <thead>
                    <tr>
                        <th class="border-left-0 text-start w-150" scope="col">
                            Date 
                        </th>
                        <th class="border-left-0 text-start w-150" scope="col">
                            Transaction ID 
                        </th>
                        <th class="border-left-0 text-start w-150" scope="col">
                            Description
                        </th>
                        <th class="border-left-0 text-center" scope="col">
                            Amount
                        </th>
                        <th class="border-right-0 text-center" scope="col">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="border-left-0 text-start">March 27, 2021</td>
                        <td class="text-start">#234242353525</td>
                        <td class="text-start">Store Name</td>
                        <td class="text-center">-$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start">March 01, 2021</td>
                        <td class="text-start">#234242353525</td>
                        <td class="text-start">
                            <button class="btn link-invoice">
                                Invoice for February 2021
                            </button>
                        </td>
                        <td class="text-center">$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">   
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start">Feb 01, 2021</td>
                        <td class="text-start">#234242353525</td>
                        <td class="text-start">Store Name</td>
                        <td class="text-center">-$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">   
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start">Dec 30, 2020</td>
                        <td class="text-start">#234242353525</td>
                        <td class="text-start">
                            <button class="btn link-invoice">
                                Invoice for February 2021
                            </button>
                        </td>
                        <td class="text-center">$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">   
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start">Dec 29, 2020</td>
                        <td class="text-start">#234242353525</td>
                        <td class="text-start">Store Name</td>
                        <td class="text-center">-$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">   
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start">Dec 27, 2020</td>
                        <td class="text-start">#234242353525</td>
                        <td class="text-start">Store Name</td>
                        <td class="text-center">-$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">   
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start">Dec 26, 2020</td>
                        <td class="text-start">#234242353525</td>
                        <td class="text-start">Store Name</td>
                        <td class="text-center">-$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">   
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start">Dec 25, 2020</td>
                        <td class="text-start">#234242353525</td>
                        <td class="text-start">Store Name</td>
                        <td class="text-center">-$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">   
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>